import SORT_ORDER from 'src/enums/sortOrder';
import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import { ColumnSorting } from '../QaErrorsList/QaErrorsTable/QaErrorsTable.config';
import { Filters } from '../QaErrorsProvider';
import { QaError, QaErrorsList } from '../types/QaErrors';
import { getQaErrors } from '../services/qaErrors.service';

export type QaErrorsListState = FetchState<QaError[]> & {
  total: number;
  page: number;
  offset: number;
  size: number;
};

type UseQaErrorsListFetchParams = {
  filters: Filters;
  sorting: ColumnSorting;
  page: number;
  pageSize: number;
};

const initialState: QaErrorsListState = {
  loading: false,
  error: false,
  data: null,
  total: 0,
  page: 1,
  offset: 1,
  size: 0,
};

const useQaErrorsListFetch = ({
  filters,
  sorting,
  page,
  pageSize,
}: UseQaErrorsListFetchParams): [QaErrorsListState, () => void] => {
  const params: QaErrorsList.Request = {
    ...filters,
    sortingOrder: SORT_ORDER[sorting.order],
    sortingColumn: sorting.field,
    size: pageSize,
    offset: page > 1 ? (page - 1) * pageSize + 1 : 1,
  };

  const [{ loading, data, error }, refetch] = useFetchReducer(() => getQaErrors(params), Object.values(params));

  const state: QaErrorsListState = { ...initialState, loading, error };

  if (data === null) {
    return [state, refetch];
  }

  const { errorsList, totalRecords } = data;

  return [
    {
      ...state,
      data: errorsList,
      total: Number(totalRecords),
    },
    refetch,
  ];
};

export default useQaErrorsListFetch;
